<div class="placeholders">
    <fui-alerts></fui-alerts>
</div>

<wbo-login-podium>
    <div class="profile">
        <div class="profile-header">
            <div class="profile-header-media">
                <div class="profile-header-media-object">
                    <fui-pos-logo id="logo" [type]="'fedelta'"></fui-pos-logo>
                </div>
            </div>
            <div class="profile-header-title">{{'wbo.user-profile-setup.title' | translate}}</div>
        </div>
        <div class="profile-main">
            <form class="form" id="user-profile" name="form" (ngSubmit)="proceed()">
                <div class="form-main" [formGroup]="formGroup">
                    <div class="form-fields">
                        <div class="form-fields-field">
                            <fui-text-control id="firstName" [label]="'wbo.user-profile-setup.label.firstName'"
                                              formControlName="firstName" [control]="formGroup.get('firstName')"
                                              [(ngModel)]="user.firstName"
                                              [placeholder]="'wbo.user-profile-setup.placeholder.firstName'">
                            </fui-text-control>
                        </div>
                        <div class="form-fields-field">
                            <fui-text-control id="lastName" [label]="'wbo.user-profile-setup.label.lastName'"
                                              formControlName="lastName" [control]="formGroup.get('lastName')"
                                              [(ngModel)]="user.lastName"
                                              [placeholder]="'wbo.user-profile-setup.placeholder.lastName'">
                            </fui-text-control>
                        </div>
                        <div class="form-fields-field">
                            <fui-text-control id="email" [label]="'wbo.user-profile-setup.label.email'"
                                              formControlName="email" [control]="formGroup.get('email')"
                                              [(ngModel)]="user.email"
                                              [placeholder]="'wbo.user-profile-setup.placeholder.email'">
                            </fui-text-control>
                        </div>
                        <div class="form-fields-field">
                            <fui-text-control id="userName" [label]="'wbo.user-profile-setup.label.userName'"
                                              formControlName="userName" [control]="formGroup.get('userName')"
                                              [(ngModel)]="user.userName"
                                              [placeholder]="'wbo.user-profile-setup.placeholder.userName'">
                            </fui-text-control>
                        </div>
                        <div class="form-fields-field">
                            <fui-password-control id="password" [label]="'wbo.user-profile-setup.label.password'"
                                              formControlName="password" [control]="formGroup.get('password')"
                                              [(ngModel)]="user.password"
                                              [placeholder]="'wbo.user-profile-setup.placeholder.password'">
                            </fui-password-control>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <div class="form-actions-action">
                        <fui-submit-button id="proceed-button" class="form-actions-action-proceed"
                                           [title]="'wbo.user-profile-completion.button.proceed'"></fui-submit-button>
                    </div>
                </div>
                <div class="form-tools">
                    <div class="form-fields">
                        <div class="form-fields-field">
                            <fui-checkbox-control id="login-remember" [label]="'wbo.user-profile-setup.label.remember'"
                                                  name="remember"
                                                  [(ngModel)]="remember"></fui-checkbox-control>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</wbo-login-podium>
